import React, { useContext } from "react";
import { ProjectContext } from "../../context/project_context";
import { Button } from "@mui/material";

const ProjectNew = () => {
  const { project, updateProjectStatus } = useContext(ProjectContext);

  const handleStart = async () => {
    await updateProjectStatus(project.id, "upload_video");
  };

  return (
    <div className="project-new-container">
      <Button 
        variant="contained"
        color="primary"
        onClick={handleStart}
      >
        Start Project
      </Button>
    </div>
  );
};

export default ProjectNew; 